import { Stack } from "@mui/material";
import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError() as any;
  console.error(error);

  return (
    <Stack
      sx={{ width: "100%", height: "100%" }}
      id="error-page"
      alignItems={"center"}
      justifyContent={"center"}
    >
      <h1>Oops!</h1>
      <p>Có lỗi xảy ra.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </Stack>
  );
}
